var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogomark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 73,
    viewBox: "0 0 106 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.735 4.20793C104.724 4.21893 104.713 4.21892 104.713 4.24192L104.69 4.26393C104.656 4.29893 104.644 4.30992 104.656 4.30992L71.9647 38.6599L64.2647 46.7529C64.2509 46.7427 64.2353 46.7353 64.2187 46.7309L64.0827 46.6629L32.5967 32.6129L33.7447 32.0789L39.0527 29.5899L46.4527 26.1229C46.4658 26.1119 46.4812 26.104 46.4977 26.0999H46.5097L101.73 0.240913C102.257 -0.006631 102.854 -0.0655376 103.42 0.0740728C103.985 0.213684 104.486 0.543359 104.838 1.00791C105.19 1.47247 105.372 2.04375 105.353 2.62623C105.334 3.20871 105.116 3.76708 104.735 4.20793Z",
    fill: "url(#paint0_linear_51_503)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.421548 21.3831H0.433541C0.421541 21.3941 0.421546 21.4051 0.410546 21.4171C0.409695 21.4109 0.410243 21.4047 0.412148 21.3988C0.414053 21.3929 0.417267 21.3875 0.421548 21.3831Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2688 46.753C64.2688 46.753 63.2338 46.378 61.4378 45.696C59.6378 44.98 57.0728 44.026 54.0158 42.775C50.9578 41.547 47.3998 40.081 43.6158 38.467C39.8318 36.853 35.8068 35.08 31.7828 33.307C29.7828 32.397 27.7828 31.499 25.8158 30.601C23.8488 29.726 21.9278 28.801 20.0528 27.942C16.3248 26.202 12.8578 24.542 9.90186 23.077C8.41286 22.36 7.07185 21.677 5.86685 21.065C5.27585 20.765 4.70785 20.473 4.20685 20.235C3.75714 20.0232 3.25859 19.9369 2.76386 19.985C2.04672 20.0502 1.37478 20.3636 0.863846 20.871C0.818954 20.9136 0.77718 20.9594 0.738846 21.008C0.703846 21.042 0.669855 21.087 0.638855 21.121C0.605622 21.1516 0.575166 21.1851 0.547852 21.221C0.946069 20.5778 1.56659 20.1033 2.29161 19.8874C3.01664 19.6715 3.79568 19.7294 4.48085 20.05L32.6028 32.61L33.7508 32.076C37.3508 33.701 40.9458 35.327 44.3108 36.907C48.0388 38.646 51.5058 40.317 54.4718 41.772C57.4378 43.227 59.8718 44.488 61.5878 45.352C62.8718 46.012 63.7358 46.466 64.0878 46.66L64.2238 46.728C64.2403 46.7334 64.2555 46.7419 64.2688 46.753Z",
    fill: "black"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2692 46.753L51.8692 59.791C51.8605 59.8013 51.8531 59.8127 51.8472 59.825C51.8472 59.825 51.8352 59.814 51.8352 59.825L41.9462 70.225C41.8031 70.3774 41.6516 70.5216 41.4922 70.657C40.8701 71.184 40.1457 71.5767 39.3645 71.8101C38.5833 72.0436 37.7622 72.1129 36.9529 72.0136C36.1436 71.9143 35.3637 71.6486 34.6621 71.2333C33.9605 70.8179 33.3524 70.2618 32.8762 69.6L13.1542 42.206V42.195C13.1312 42.183 13.1312 42.172 13.1312 42.172L12.8932 41.842L0.617229 24.803C0.261897 24.3316 0.0503143 23.7676 0.00791486 23.1787C-0.0344845 22.5899 0.094106 22.0014 0.378231 21.484C0.388789 21.4706 0.396601 21.4553 0.401226 21.439C0.402758 21.439 0.404277 21.4387 0.405681 21.4381C0.407085 21.4374 0.408353 21.4365 0.409389 21.4354C0.410425 21.4343 0.411203 21.4329 0.411693 21.4315C0.412183 21.43 0.412366 21.4285 0.412227 21.427V21.416C0.411376 21.4098 0.411924 21.4036 0.413829 21.3977C0.415734 21.3918 0.418948 21.3864 0.423229 21.382H0.435222C0.457222 21.336 0.503229 21.291 0.548229 21.223C0.946446 20.5798 1.56697 20.1052 2.29199 19.8893C3.01701 19.6735 3.79606 19.7314 4.48123 20.052L32.6032 32.612L64.0892 46.662L64.2253 46.73C64.2411 46.7348 64.2561 46.7426 64.2692 46.753Z",
    fill: "url(#paint1_linear_51_503)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9647 38.6601L64.2647 46.7531C64.2509 46.7429 64.2353 46.7354 64.2187 46.7311L32.5967 32.6131L33.7447 32.0791L39.0527 29.5901L71.9647 38.6601Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.421521 21.3831H0.433514C0.421514 21.4051 0.410519 21.4171 0.410519 21.4281C0.408891 21.4123 0.412778 21.3964 0.421521 21.3831Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2688 46.753C64.2688 46.753 63.2338 46.378 61.4378 45.696C59.6378 44.98 57.0728 44.026 54.0158 42.775C50.9578 41.547 47.3998 40.081 43.6158 38.467C39.8318 36.853 35.8068 35.08 31.7828 33.307C29.7828 32.397 27.7828 31.499 25.8158 30.601C23.8488 29.726 21.9278 28.801 20.0528 27.942C16.3248 26.202 12.8578 24.542 9.90186 23.077C8.41286 22.36 7.07185 21.677 5.86685 21.065C5.27585 20.765 4.70785 20.473 4.20685 20.235C3.75714 20.0232 3.25859 19.9369 2.76386 19.985C2.04672 20.0502 1.37478 20.3636 0.863846 20.871C0.818954 20.9136 0.77718 20.9594 0.738846 21.008C0.702332 21.0427 0.668884 21.0806 0.638855 21.121C0.605622 21.1516 0.575166 21.1851 0.547852 21.221C0.946069 20.5778 1.56659 20.1033 2.29161 19.8874C3.01664 19.6715 3.79568 19.7294 4.48085 20.05L32.6028 32.61L64.0888 46.66L64.2248 46.728C64.2409 46.7335 64.2558 46.742 64.2688 46.753Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8333 59.8251L41.9443 70.2251C41.8012 70.3775 41.6496 70.5217 41.4903 70.6571C40.8682 71.1841 40.1438 71.5768 39.3626 71.8102C38.5814 72.0437 37.7603 72.113 36.951 72.0137C36.1418 71.9144 35.3618 71.6487 34.6602 71.2334C33.9586 70.818 33.3505 70.2619 32.8743 69.6001L13.1523 42.2061C13.2893 42.3541 13.8573 43.0241 14.7523 44.1061C15.7523 45.3561 17.2303 47.1181 18.9243 49.2781C20.6183 51.4381 22.5843 53.9721 24.6413 56.7231C26.7103 59.4511 28.8583 62.4231 31.0183 65.3731L32.6093 67.6131L33.3933 68.7261L33.5983 68.9991C33.6502 69.0788 33.7073 69.1549 33.7693 69.2271C33.8892 69.3897 34.0231 69.5416 34.1693 69.6811C34.6933 70.211 35.3275 70.6191 36.0269 70.8764C36.7263 71.1337 37.4738 71.234 38.2163 71.1701C38.9424 71.1104 39.6476 70.8974 40.2853 70.5451C40.5905 70.377 40.8762 70.1758 41.1373 69.9451L41.3653 69.7521L41.4553 69.6721L41.5553 69.5581L41.9753 69.1491C43.0893 68.0351 44.1583 67.0011 45.1583 66.0491C47.1253 64.1391 48.8303 62.6051 49.9893 61.4911C51.0283 60.5451 51.6863 59.9451 51.8333 59.8251Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.042 3.66198C105.181 3.34769 105.25 3.00634 105.242 2.66244C105.234 2.31855 105.15 1.98066 104.997 1.673C104.793 1.21469 104.441 0.837739 103.998 0.602167C103.556 0.366595 103.047 0.285921 102.553 0.37298C101.931 0.578737 101.336 0.857358 100.78 1.203C100.132 1.532 99.4495 1.88498 98.7445 2.24798C95.9025 3.71498 92.5725 5.38601 88.9915 7.14801C87.1915 8.01201 85.3435 8.94798 83.4445 9.82998C81.5456 10.712 79.6376 11.638 77.7166 12.547C73.8516 14.347 69.9866 16.127 66.3376 17.753C62.6886 19.379 59.2796 20.867 56.3376 22.106C53.3936 23.368 50.9155 24.334 49.1875 25.05C47.6985 25.65 46.7436 26.005 46.5166 26.096L101.737 0.236994C102.264 -0.00811072 102.859 -0.0651325 103.424 0.0754334C103.988 0.216 104.487 0.545668 104.838 1.00952C105.189 1.47337 105.37 2.0434 105.351 2.62466C105.333 3.20592 105.116 3.76332 104.737 4.20401C104.858 4.03523 104.96 3.85342 105.042 3.66198Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.428 3.35499L98.2794 7.709C95.2901 10.8463 92.3044 13.9834 89.3224 17.12L48.1064 27.862C57.7684 23.338 67.4351 18.814 77.1064 14.29C84.8011 10.69 92.5011 7.08301 100.206 3.46901C100.945 3.12801 101.684 2.775 102.423 2.434C103.328 2.002 102.813 2.94499 102.428 3.35499Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4155 47.5151C58.5281 49.4825 56.6488 51.4564 54.7775 53.4371C54.2545 53.9831 53.7325 54.5371 53.2095 55.0851L3.22852 22.0991C3.80349 22.2015 4.35448 22.4097 4.85352 22.7131C12.9475 26.3271 21.0445 29.9418 29.1445 33.5571C39.5691 38.2158 49.9928 42.8685 60.4155 47.5151Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_503",
    x1: 12.8794,
    y1: 23.3765,
    x2: 105.354,
    y2: 23.3765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_503",
    x1: 56.8782,
    y1: 36.5482,
    x2: 11.5601,
    y2: 54.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.162,
    stopColor: "#FBC000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#FBB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#FBA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#FA8900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#FA6800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#F93F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967,
    stopColor: "#F81000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F80300"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomark);
export default __webpack_public_path__ + "static/media/Logomark.2fbe2e87ebf5807d128b79a9582dc506.svg";
export { ForwardRef as ReactComponent };